// extracted by mini-css-extract-plugin
export default {"cardHeader":"YPO5xxnmNMj6bRiKPXU6","chevron":"ewFsgh_g4ddASZ8023_i","ticketsHistoryContainer":"_wfGxa84YVZrZN0xK2DY","finishWork":"r5L70W1UHK_I_MDwQs_P"};